// Inisialisasi seluruh interaksi di halaman exchange.
(() => {
  const root = document.querySelector('[data-exchange-page]');

  if (!root) {
    return;
  }

  const formatter = new Intl.NumberFormat('id-ID', {
    maximumFractionDigits: 0,
  });

  const form = root.querySelector('[data-exchange-form]');
  const selectAll = root.querySelector('[data-exchange-select-all]');
  const returnTotalEl = root.querySelector('[data-return-total]');
  const exchangeTotalEl = root.querySelector('[data-exchange-total]');
  const additionalPaymentEl = root.querySelector('[data-additional-payment]');
  const selectedProductsEl = root.querySelector('[data-selected-products]');
  const exchangeSelectionSummaryEls = root.querySelectorAll('[data-exchange-selection-summary]');
  const submitButton = root.querySelector('[data-exchange-submit]');
  const messageEl = root.querySelector('[data-exchange-message]');
  const chooseProductsButton = root.querySelector('[data-choose-products]');
  const fileInput = root.querySelector('[data-exchange-files]');
  const selectFileButton = root.querySelector('[data-select-file]');
  const addFileButton = root.querySelector('[data-add-file]');
  const fileNameEl = root.querySelector('[data-file-name]');
  const fileListEl = root.querySelector('[data-file-list]');
  const categoryInput = root.querySelector('[data-exchange-category]');
  const level1Input = root.querySelector('[data-exchange-level1]');
  const level2Input = root.querySelector('[data-exchange-level2]');
  const exchangeItems = new Map();
  let selectedFiles = [];
  let fileSelectionMode = 'replace';

  // Format nilai cents dari Shopify menjadi tampilan mata uang.
  const money = (cents) => `Rp${formatter.format(Math.max(0, cents) / 100)}`;

  // Escape text sebelum dimasukkan ke HTML string.
  const escapeHtml = (value) => {
    const div = document.createElement('div');
    div.textContent = value || '';
    return div.innerHTML;
  };

  // Ambil semua order item yang sedang dicentang untuk diretur.
  const selectedReturnItems = () => {
    return [...root.querySelectorAll('[data-return-item]')]
      .filter((item) => {
        const checkbox = item.querySelector('[data-return-checkbox]');
        return checkbox?.checked && !checkbox.disabled;
      })
      .map((item) => {
        const quantityInput = item.querySelector('[data-return-quantity]');
        const maxQuantity = Math.max(1, Number(quantityInput?.max || 1));
        const quantity = Math.min(maxQuantity, Math.max(1, Number(quantityInput?.value || 1)));
        const unitPrice = Number(item.dataset.price || 0);

        return {
          orderId: item.dataset.orderId,
          orderName: item.dataset.orderName,
          lineItemId: item.dataset.lineItemId,
          productId: item.dataset.productId,
          variantId: item.dataset.variantId,
          title: item.dataset.title,
          variantTitle: item.dataset.variantTitle,
          image: item.dataset.image,
          maxQuantity,
          quantity,
          unitPrice,
          totalPrice: unitPrice * quantity,
        };
      });
  };

  // Ambil semua item yang sudah masuk ke daftar exchange.
  const selectedExchangeItems = () => [...exchangeItems.values()];

  // Sinkronkan array file custom ke input file asli agar tetap bisa divalidasi browser.
  const syncFileInput = () => {
    if (!fileInput) {
      return;
    }

    const dataTransfer = new DataTransfer();
    selectedFiles.forEach((file) => dataTransfer.items.add(file));
    fileInput.files = dataTransfer.files;
  };

  // Render nama file utama dan list file yang sudah dipilih user.
  const renderSelectedFiles = () => {
    if (fileNameEl) {
      if (selectedFiles.length === 0) {
        fileNameEl.textContent = root.dataset.noFileChosen || '';
      } else if (selectedFiles.length === 1) {
        fileNameEl.textContent = selectedFiles[0].name;
      } else {
        fileNameEl.textContent = `${selectedFiles.length} ${root.dataset.filesSelectedLabel || ''}`.trim();
      }
    }

    if (fileListEl) {
      fileListEl.innerHTML = selectedFiles
        .map((file, index) => {
          return `
            <li>
              <span>${escapeHtml(file.name)}</span>
              <button
                type="button"
                class="exchange-file-upload__remove"
                data-remove-file="${index}"
                aria-label="${escapeHtml(root.dataset.removeFileLabel)}"
              >
                ${escapeHtml(root.dataset.removeFileLabel)}
              </button>
            </li>
          `;
        })
        .join('');
      fileListEl.hidden = selectedFiles.length === 0;
    }
  };

  // Update daftar file ketika user memilih atau menambah attachment.
  const updateFiles = (files, mode) => {
    const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB dalam bytes
    const MAX_FILE_SIZE_MB = 2;

    // Filter file yang melebihi 2MB
    const validFiles = [];
    const invalidFiles = [];

    for (const file of files) {
      if (file.size <= MAX_FILE_SIZE) {
        validFiles.push(file);
      } else {
        invalidFiles.push(file.name);
      }
    }

    // Tampilkan pesan error jika ada file yang melebihi 2MB
    if (invalidFiles.length > 0) {
      const fileNames = invalidFiles.join(', ');
      setMessage(`❌ File ${fileNames} melebihi ${MAX_FILE_SIZE_MB}MB.`, 'error');

      // Hilangkan pesan setelah 3 detik
      setTimeout(() => {
        if (messageEl) {
          messageEl.textContent = '';
          messageEl.hidden = true;
          messageEl.classList.remove('is-error', 'is-success');
        }
      }, 3000);
    }

    // Jika tidak ada file valid, return
    if (validFiles.length === 0) {
      return;
    }

    const nextFiles = [...validFiles];
    selectedFiles = mode === 'append' ? selectedFiles.concat(nextFiles) : nextFiles;
    syncFileInput();
    renderSelectedFiles();
    updateState();
  };

  // Hitung total harga produk return, produk exchange, dan selisih pembayaran.
  const totals = () => {
    const returnTotal = selectedReturnItems().reduce((sum, item) => sum + item.totalPrice, 0);
    const exchangeTotal = selectedExchangeItems().reduce((sum, item) => sum + item.totalPrice, 0);

    return {
      returnTotal,
      exchangeTotal,
      additionalPayment: Math.max(0, exchangeTotal - returnTotal),
    };
  };

  // Tampilkan pesan status submit ke user.
  const setMessage = (text, type) => {
    if (!messageEl) {
      return;
    }

    messageEl.textContent = text;
    messageEl.hidden = false;
    messageEl.classList.toggle('is-success', type === 'success');
    messageEl.classList.toggle('is-error', type === 'error');
  };

  // Render kartu produk yang dipilih untuk exchange di panel kanan.
  const renderSelectedProducts = () => {
    if (!selectedProductsEl) {
      return;
    }

    const items = selectedExchangeItems();

    if (items.length === 0) {
      selectedProductsEl.innerHTML = `<p class="exchange-empty">${escapeHtml(root.dataset.selectedEmpty)}</p>`;
      return;
    }

    selectedProductsEl.innerHTML = items
      .map((item) => {
        const variant =
          item.variantTitle && item.variantTitle !== 'Default Title'
            ? `
              <p class="exchange-order-item__variant">
                ${escapeHtml(root.dataset.variantLabel)}: ${escapeHtml(item.variantTitle)}
              </p>
            `
            : '';
        const totalPrice = item.unitPrice * item.quantity;

        return `
          <article
            class="exchange-selected-item"
            data-selected-line-item-id="${item.lineItemId}"
          >
            <div class="exchange-selected-item__content">
              <div class="exchange-order-item__media">
                ${item.image
            ? `<img src="${escapeHtml(item.image)}" alt="" width="56" height="56" loading="lazy">`
            : ''
          }
              </div>

              <div class="exchange-order-item__content">
                <div class="exchange-order-item__content-inner-top">
                  <p class="exchange-order-item__title">
                    ${escapeHtml(item.title)}
                  </p>
                  ${variant}
                </div>

                <div class="exchange-order-item__content-divider"></div>

                <div class="exchange-order-item__content-inner-bottom">
                  <label class="exchange-quantity">
                    <span>${escapeHtml(root.dataset.quantityLabel)}</span>
                    <input
                      type="number"
                      min="1"
                      max="${item.maxQuantity}"
                      value="${item.quantity}"
                      data-exchange-quantity
                    >
                  </label>

                  <div class="exchange-order-item__price">
                    <span>${escapeHtml(root.dataset.priceLabel)}</span>
                    <strong>${money(item.unitPrice)}</strong>
                  </div>
                </div>
                <div class="exchange-order-item__total"> 
                  <span>Total</span>
                  <span class="bold-text" data-total="${totalPrice}">${money(totalPrice)}</span>
                </div>
              </div>
            </div>

            <button
              class="exchange-button exchange-remove"
              type="button"
              data-remove-exchange-product
            >
              ${escapeHtml(root.dataset.deleteLabel)}
            </button>
          </article>
        `;
      })
      .join('');
  };

  // Refresh semua state UI: total harga, summary tersembunyi, dan tombol submit.
  // Refresh semua state UI: total harga, summary tersembunyi, dan tombol submit.
  const updateState = () => {
    const currentTotals = totals();

    if (returnTotalEl) {
      returnTotalEl.textContent = money(currentTotals.returnTotal);
    }

    if (exchangeTotalEl) {
      exchangeTotalEl.textContent = money(currentTotals.exchangeTotal);
    }

    if (additionalPaymentEl) {
      additionalPaymentEl.textContent = money(currentTotals.additionalPayment);
    }

    if (submitButton) {
      const hasReturnItems = selectedReturnItems().length > 0;
      const hasExchangeItems = selectedExchangeItems().length > 0;
      const hasReason = Boolean(root.querySelector('[data-exchange-reason]')?.value);
      const hasCategory = Boolean(root.querySelector('[data-exchange-category]')?.value);
      const hasFiles = (fileInput?.files.length || 0) > 0;

      // ============================================================
      // DEBUG - Cek nilai setiap kondisi
      // ============================================================
      // console.log('========== DEBUG SUBMIT BUTTON ==========');
      // console.log('hasReturnItems:', hasReturnItems, '| Jumlah:', selectedReturnItems().length);
      // console.log('hasExchangeItems:', hasExchangeItems, '| Jumlah:', selectedExchangeItems().length);
      // console.log('hasReason:', hasReason, '| Value:', root.querySelector('[data-exchange-reason]')?.value);
      // console.log('hasCategory:', hasCategory, '| Value:', root.querySelector('[data-exchange-category]')?.value);
      // console.log('hasFiles:', hasFiles, '| Jumlah:', fileInput?.files.length);
      // console.log('Button disabled:', !(hasReturnItems && hasExchangeItems && hasReason && hasCategory && hasFiles));
      // console.log('==========================================');

      submitButton.disabled = !(hasReturnItems && hasExchangeItems && hasReason && hasCategory && hasFiles);
    }

    exchangeSelectionSummaryEls.forEach((element) => {
      element.hidden = selectedExchangeItems().length === 0;
    });
  };

  // Update state saat pilihan order, quantity, reason, atau file berubah.
  root.querySelectorAll('[data-return-checkbox], [data-return-quantity], [data-exchange-reason], [data-exchange-files], [data-exchange-category], [data-exchange-level1], [data-exchange-level2]').forEach((element) => {
    element.addEventListener('change', updateState);
    element.addEventListener('input', updateState);
  });

  // Pilih atau hapus centang semua order item di panel kiri.
  selectAll?.addEventListener('change', () => {
    root.querySelectorAll('[data-return-checkbox]:not(:disabled)').forEach((checkbox) => {
      checkbox.checked = selectAll.checked;
    });
    updateState();
  });

  // Salin item return yang dicentang ke daftar exchange di panel kanan.
  chooseProductsButton?.addEventListener('click', () => {
    exchangeItems.clear();

    selectedReturnItems().forEach((item) => {
      exchangeItems.set(item.lineItemId, item);
    });

    renderSelectedProducts();
    updateState();
  });

  // Buka file picker untuk mengganti daftar file yang ada.
  selectFileButton?.addEventListener('click', () => {
    fileSelectionMode = 'replace';
    fileInput?.click();
  });

  // Buka file picker untuk menambahkan file ke daftar yang ada.
  addFileButton?.addEventListener('click', () => {
    fileSelectionMode = 'append';
    fileInput?.click();
  });

  // Proses file yang dipilih dari file picker.
  fileInput?.addEventListener('change', () => {
    updateFiles(fileInput.files, fileSelectionMode);
    fileInput.value = '';
    syncFileInput();
  });

  // Tangani klik global untuk menghapus produk exchange atau attachment.
  root.addEventListener('click', (event) => {
    const removeButton = event.target.closest('[data-remove-exchange-product]');
    const removeFileButton = event.target.closest('[data-remove-file]');

    if (removeFileButton) {
      selectedFiles.splice(Number(removeFileButton.dataset.removeFile), 1);
      syncFileInput();
      renderSelectedFiles();
      updateState();
      return;
    }

    if (removeButton) {
      const selectedItem = removeButton.closest('[data-selected-line-item-id]');
      const returnItem = root.querySelector(`[data-return-item][data-line-item-id="${CSS.escape(selectedItem.dataset.selectedLineItemId)}"]`);
      const checkbox = returnItem?.querySelector('[data-return-checkbox]');

      exchangeItems.delete(selectedItem.dataset.selectedLineItemId);

      if (checkbox) {
        checkbox.checked = false;
      }

      renderSelectedProducts();
      updateState();
    }
  });

  // Sinkronkan quantity produk exchange dengan quantity produk return yang sama.
  selectedProductsEl?.addEventListener('input', (event) => {
    const input = event.target.closest('[data-exchange-quantity]');

    if (!input) {
      return;
    }

    const selectedItem = input.closest('[data-selected-line-item-id]');
    const exchangeItem = exchangeItems.get(selectedItem.dataset.selectedLineItemId);
    const returnItem = root.querySelector(`[data-return-item][data-line-item-id="${CSS.escape(selectedItem.dataset.selectedLineItemId)}"]`);
    const returnQuantityInput = returnItem?.querySelector('[data-return-quantity]');

    if (!returnQuantityInput || !exchangeItem) {
      return;
    }

    const quantity = Math.min(
      Number(returnQuantityInput.max || 1),
      Math.max(1, Number(input.value || 1))
    );

    returnQuantityInput.value = quantity;
    exchangeItem.quantity = quantity;
    exchangeItem.totalPrice = exchangeItem.unitPrice * quantity;
    renderSelectedProducts();
    updateState();
  });

  // ============================================================
  // STRUKTUR HIERARCHY REASON DENGAN KATEGORI
  // ============================================================
  const reasonHierarchy = {
    "Kualitas Produk": {
      "Produk Rusak": {
        reasons: [
          { text: "Botol pecah", category: "Issue with primary packaging" },
          { text: "Botol rembes", category: "Issue with primary packaging" },
          { text: "Roll on tidak ada", category: "Issue with primary packaging" },
          { text: "Roll on longgar", category: "Issue with primary packaging" },
          { text: "Produk tidak bisa dibuka", category: "Issue with primary packaging" },
          { text: "Packaging produk retak", category: "Issue with primary packaging" },
          { text: "Produk tidak lengkap", category: "Incomplete product" },
          { text: "Hanya diterima box packaging (tidak ada produknya)", category: "Incomplete product" },
          { text: "Box packaging robek", category: "Issue with secondary packaging" },
          { text: "Box packaging basah", category: "Issue with secondary packaging" },
          { text: "Produk tidak sesuai foto", category: "Damage goods" },
          { text: "Ukuran produk tidak sesuai size chart", category: "Damage goods" },
          { text: "Size label/ hangtag tidak sesuai", category: "Damage goods" },
          { text: "Isi produk kosong", category: "Damage goods" },
          { text: "Isi produk tumpah", category: "Damage goods" },
          { text: "Isi produk hancur", category: "Damage goods" },
          { text: "Jahitan tidak rapi", category: "Damage goods" },
          { text: "Jahitan putus", category: "Damage goods" },
          { text: "Terdapat bolong pada produk", category: "Damage goods" },
          { text: "Terdapat noda pada produk", category: "Damage goods" },
          { text: "Banyak benang keluar pada jahitan", category: "Damage goods" },
          { text: "Produk tidak sesuai warna", category: "Damage goods" },
          { text: "Produk berbau tidak seharusnya", category: "Damage goods" },
          { text: "Produk bertekstur tidak seharusnya", category: "Damage goods" },
          { text: "Produk berjamur", category: "Damage goods" },
          { text: "Ukuran kanan dan kiri berbeda", category: "Damage goods" },
          { text: "Produk expired", category: "Damage goods" },
          { text: "Produk Rusak / Malfungsi", category: "Damage goods" },
          { text: "Produk Kotor", category: "Damage goods" }
        ]
      }
    },
    "Service": {
      "Penanganan": {
        reasons: [
          { text: "Salah kirim produk", category: "Wrong product shipped" },
          { text: "Paket tertukar dengan customer lain/crosslabel", category: "Wrong product shipped" },
          { text: "Kurang kirim", category: "Warehouse issue" },
          { text: "Produk terkirim lebih", category: "Warehouse issue" },
          { text: "Produk tidak ditemukan di slot", category: "Out of stock" },
          { text: "Produk habis tetapi masih live di marketplace", category: "Out of stock" }
        ]
      },
      "Pengiriman": {
        reasons: [
          { text: "Kurir mengirim lebih dari sekali", category: "Courier Error" },
          { text: "Produk hilang saat pengiriman (dicuri/jatuh)", category: "Courier Error" },
          { text: "Pesanan terlambat sampai", category: "Courier Error" },
          { text: "Pesanan terlambat dipickup", category: "Courier Error" },
          { text: "Rusak saat pengiriman", category: "Courier Error" },
          { text: "Kurir salah alamat", category: "Courier Error" },
          { text: "Pengiriman gagal/tidak terkirim", category: "Courier Error" },
          { text: "Paket hilang", category: "Courier Error" },
          { text: "Paket tertukar", category: "Courier Error" },
          { text: "Tidak kunjung mendapatkan kurir", category: "System marketplace error" },
          { text: "Produk sampai di customer tetapi sudah tercancel", category: "System marketplace error" },
          { text: "Resi gagal discan kurir", category: "System marketplace error" }
        ]
      },
      "Customer": {
        reasons: [
          { text: "Tukar size karena kekecilan", category: "Item does not fit" },
          { text: "Tukar size karena kebesaran", category: "Item does not fit" },
          { text: "Customer salah memilih varian", category: "Customer error" },
          { text: "Customer salah membeli barang", category: "Customer error" },
          { text: "Produk tidak sesuai ekspektasi customer", category: "The product does not meet customer expectations" },
          { text: "Penipuan terhadap pembelian", category: "Fraud" },
          { text: "Customer tidak jadi membeli ketika barang sudah sampai", category: "Wardrobing" }
        ]
      },
      "Lainnya": {
        reasons: [
          { text: "Admin salah input deksripsi", category: "Others" },
          { text: "Admin salah upload produk", category: "Others" }
        ]
      }
    }
  };

  // ============================================================
  // FUNGSI UNTUK MENDAPATKAN KATEGORI DARI ALASAN
  // ============================================================
  const getReasonCategory = (selectedReason) => {
    for (const [level1, subCategories] of Object.entries(reasonHierarchy)) {
      for (const [level2, data] of Object.entries(subCategories)) {
        if (data.reasons) {
          const found = data.reasons.find(item => item.text === selectedReason);
          if (found) {
            return {
              level1: level1,
              level2: level2,
              category: found.category
            };
          }
        }
      }
    }
    return null;
  };

  // ============================================================
  // SUBMIT FORM - ONLY CONSOLE.LOG (TESTING MODE)
  // ============================================================
  form?.addEventListener('submit', async (event) => {
    event.preventDefault();

    updateState();

    if (submitButton.disabled) {
      setMessage(root.dataset.validationMessage, 'error');
      return;
    }

    // =========================
    // TESTING MODE - Only console.log
    // =========================
    console.log('========== EXCHANGE FORM DATA ==========');

    // 1. Reason Data
    const reasonValue = root.querySelector('[data-exchange-reason]').value;
    const categoryValue = root.querySelector('[data-exchange-category]').value;
    const level1Value = root.querySelector('[data-exchange-level1]').value;
    const level2Value = root.querySelector('[data-exchange-level2]').value;

    // console.log('📋 REASON DATA:');
    // console.log('  - reason:', reasonValue);
    // console.log('  - category:', categoryValue);
    // console.log('  - level1:', level1Value);
    // console.log('  - level2:', level2Value);

    // 2. Note
    const noteValue = root.querySelector('[data-exchange-note]').value;
    // console.log('📝 NOTE:', noteValue);

    // 3. Selected Products
    const items = selectedExchangeItems().map((item) => ({
      orderId: item.orderId,
      orderName: item.orderName,
      lineItemId: item.lineItemId,
      productId: item.productId,
      variantId: item.variantId,
      title: item.title,
      variantTitle: item.variantTitle,
      quantity: item.quantity,
      unitPrice: item.unitPrice,
      totalPrice: item.totalPrice,
    }));
    // console.log('📦 SELECTED PRODUCTS:', items);
    // console.log('  - Total items:', items.length);

    // 4. Files
    const files = [];
    for (const file of selectedFiles) {
      files.push({
        name: file.name,
        size: file.size,
        type: file.type,
        lastModified: file.lastModified
      });
    }
    // console.log('📎 FILES:');
    // console.log('  - Total files:', selectedFiles.length);
    // console.log('  - File details:', files);

    // 5. Totals
    const currentTotals = totals();
    // console.log('💰 TOTALS:');
    // console.log('  - Return Total:', money(currentTotals.returnTotal));
    // console.log('  - Exchange Total:', money(currentTotals.exchangeTotal));
    // console.log('  - Additional Payment:', money(currentTotals.additionalPayment));

    // 6. FormData
    const formData = new FormData();

    // =========================
    // PERUBAHAN: 
    // - reason (level 3) → dikirim sebagai level3
    // - note → dikirim sebagai reason
    // =========================
    formData.append('level3', reasonValue); // Alasan detail (Botol pecah, dll)
    formData.append('reason', noteValue); // Catatan customer jadi reason

    if (categoryValue) {
      formData.append('category', categoryValue);
      formData.append('level1', level1Value);
      formData.append('level2', level2Value);
    }

    formData.append('items', JSON.stringify(items));
    selectedFiles.forEach((file, index) => {
      formData.append(`attachments[${index}]`, file);
    });

    if (window.Shopify && window.Shopify.shop) {
      formData.append('shop', window.Shopify.shop);
    }

    // Append customer info
    if (root.dataset.nameCustomer) formData.append('customer_name', root.dataset.nameCustomer);
    if (root.dataset.emailCustomer) formData.append('customer_email', root.dataset.emailCustomer);
    if (root.dataset.idCustomer) formData.append('customer_id', root.dataset.idCustomer);

    // =========================
    // API CALL
    // =========================
    try {
      submitButton.disabled = true;
      submitButton.textContent = 'Submitting...';

      const response = await fetch('https://lux-shopify.devbdd.com/exchange-request', {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Failed to submit exchange request');
      }

      const result = await response.json();
      console.log('Exchange request successful:', result);

      setMessage(root.dataset.successMessage, 'success');

      // Reset form
      form.reset();
      selectedFiles.length = 0;
      renderSelectedFiles();
      exchangeItems.clear();
      renderSelectedProducts();
      updateState();

      // Reload page after 2 seconds so user can read the success message
      setTimeout(() => {
        window.location.reload();
      }, 2000);

    } catch (error) {
      console.error('Exchange request error:', error);
      setMessage(root.dataset.errorMessage, 'error');
    } finally {
      submitButton.disabled = false;
      submitButton.textContent = root.dataset.submitLabel || 'Submit';
      updateState();
    }
  });

  // ============================================================
  // SETUP DROPDOWN REASON BERTINGKAT
  // ============================================================
  const setupCustomDropdown = () => {
    const dropdown = root.querySelector('[data-custom-dropdown]');
    if (!dropdown) {
      return;
    }

    const trigger = dropdown.querySelector('[data-dropdown-trigger]');
    const menu = dropdown.querySelector('[data-dropdown-menu]');
    const valueText = dropdown.querySelector('[data-dropdown-value-text]');
    const hiddenInput = dropdown.querySelector('[data-exchange-reason]');
    const placeholder = root.dataset.reasonPlaceholder || valueText?.textContent || '';
    const backLabel = root.dataset.dropdownBackLabel || 'Back';
    let selectedPath = { level1: '', level2: '', level3: '' };
    let currentLevel = 1;

    // Update teks trigger sesuai posisi atau pilihan terakhir.
    const setTriggerText = () => {
      if (!valueText) {
        return;
      }

      if (selectedPath.level3) {
        valueText.textContent = selectedPath.level3;
      } else if (selectedPath.level2) {
        valueText.textContent = `${selectedPath.level1} / ${selectedPath.level2}`;
      } else if (selectedPath.level1) {
        valueText.textContent = selectedPath.level1;
      } else {
        valueText.textContent = placeholder;
      }
    };

    // Isi hidden input reason dan trigger change agar validasi submit ikut update.
    const setInputValue = (value, categoryData = null) => {
      if (!hiddenInput) {
        return;
      }

      hiddenInput.value = value;
      hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));

      // Update category, level1, level2
      if (categoryData) {
        if (categoryInput) {
          categoryInput.value = categoryData.category || '';
          categoryInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (level1Input) {
          level1Input.value = categoryData.level1 || '';
          level1Input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (level2Input) {
          level2Input.value = categoryData.level2 || '';
          level2Input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else {
        // Reset jika tidak ada category
        if (categoryInput) {
          categoryInput.value = '';
          categoryInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (level1Input) {
          level1Input.value = '';
          level1Input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (level2Input) {
          level2Input.value = '';
          level2Input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    };

    // Buka dropdown dan render level yang sedang aktif.
    const openDropdown = () => {
      dropdown.classList.add('is-open');
      trigger?.setAttribute('aria-expanded', 'true');
      renderCurrentLevel();
    };

    // Tutup dropdown dan update state aksesibilitas trigger.
    const closeDropdown = () => {
      dropdown.classList.remove('is-open');
      trigger?.setAttribute('aria-expanded', 'false');
    };

    // Render header menu dengan tombol back.
    const renderBackHeader = (targetLevel, label) => {
      return `
        <div class="custom-dropdown__header">
          <button type="button" class="custom-dropdown__back" data-dropdown-back="${targetLevel}">
            <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M5 9L1 5L5 1" stroke="#8F9AA3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            ${escapeHtml(backLabel)}
          </button>
          <span class="custom-dropdown__current-level">${escapeHtml(label)}</span>
        </div>
      `;
    };

    // Render satu pilihan dropdown, dengan arrow jika masih punya child.
    const renderOption = (level, value, hasChildren) => {
      return `
        <button
          type="button"
          class="custom-dropdown__option"
          data-level="${level}"
          data-option-value="${escapeHtml(value)}"
        >
          <span>${escapeHtml(value)}</span>
          ${hasChildren ? '<span class="custom-dropdown__option-arrow" aria-hidden="true">&#9656;</span>' : ''}
        </button>
      `;
    };

    // Render level pertama: kategori alasan exchange.
    const renderLevel1 = () => {
      currentLevel = 1;
      // Tampilkan hanya level 1 (Kualitas Produk, Service)
      menu.innerHTML = Object.keys(reasonHierarchy)
        .map((option) => renderOption(1, option, true))
        .join('');
      setTriggerText();
    };

    // Render level kedua berdasarkan kategori yang dipilih.
    const renderLevel2 = () => {
      currentLevel = 2;
      selectedPath.level2 = '';
      selectedPath.level3 = '';
      setInputValue('');
      setTriggerText();
      const options = Object.keys(reasonHierarchy[selectedPath.level1] || {});
      menu.innerHTML = [
        renderBackHeader(1, selectedPath.level1),
        ...options.map((option) => renderOption(2, option, true)),
      ].join('');
    };

    // Render level ketiga berisi alasan detail/final.
    const renderLevel3 = () => {
      currentLevel = 3;
      selectedPath.level3 = '';
      setInputValue('');
      setTriggerText();
      const data = reasonHierarchy[selectedPath.level1]?.[selectedPath.level2];
      const options = data?.reasons || [];
      menu.innerHTML = [
        renderBackHeader(2, selectedPath.level2),
        ...options.map((option) => renderOption(3, option.text, false)),
      ].join('');
    };

    // Render ulang menu sesuai level terakhir yang tersimpan.
    const renderCurrentLevel = () => {
      if (currentLevel === 3 && selectedPath.level1 && selectedPath.level2) {
        renderLevel3();
      } else if (currentLevel === 2 && selectedPath.level1) {
        renderLevel2();
      } else {
        renderLevel1();
      }
    };

    // Toggle dropdown saat trigger diklik.
    trigger?.addEventListener('click', (event) => {
      event.stopPropagation();
      if (dropdown.classList.contains('is-open')) {
        closeDropdown();
        return;
      }

      openDropdown();
    });

    // Tangani klik option dan tombol back di dalam menu dropdown.
    menu?.addEventListener('click', (event) => {
      event.stopPropagation();
      const option = event.target.closest('[data-option-value]');
      const backButton = event.target.closest('[data-dropdown-back]');

      if (backButton) {
        const targetLevel = Number(backButton.dataset.dropdownBack);
        if (targetLevel === 1) {
          selectedPath = { level1: '', level2: '', level3: '' };
          setInputValue('');
          renderLevel1();
        } else if (targetLevel === 2) {
          selectedPath.level2 = '';
          selectedPath.level3 = '';
          setInputValue('');
          renderLevel2();
        }
        return;
      }

      if (!option) {
        return;
      }

      const value = option.dataset.optionValue || '';
      const level = Number(option.dataset.level);

      if (level === 1) {
        selectedPath.level1 = value;
        renderLevel2();
      } else if (level === 2) {
        selectedPath.level2 = value;
        renderLevel3();
      } else if (level === 3) {
        selectedPath.level3 = value;
        currentLevel = 1;
        setTriggerText();

        // Dapatkan category data untuk alasan yang dipilih
        const categoryData = getReasonCategory(value);
        setInputValue(value, categoryData);
        closeDropdown();
      }
    });

    // Tutup dropdown saat user klik area luar dropdown.
    document.addEventListener('click', (event) => {
      if (!dropdown.contains(event.target)) {
        closeDropdown();
      }
    });

    renderLevel1();
  };

  setupCustomDropdown();
  renderSelectedProducts();
  renderSelectedFiles();
  updateState();
})();